import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as SolarImage } from "../../assets/images/solarSystemImage.svg";
import Button from "@material-ui/core/Button";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import classes from "./PhoneVerification.module.scss";
import { postAxios } from "../../api/Axios";
import PersianPrice from "../../components/PersianPrice/PersianPrice";
import { verificationPhoneApi, verificationApi } from "../../api/Urls";
import { useSelector, useDispatch } from "react-redux";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  userSignOut,
  userSignInVerification,
  showAuthMessage,
  hideMessage,
  showAuthMessageSuccess,
} from "../../actions/Auth";
import { useHistory } from "react-router-dom";
import toFarsiNumber from "util/toFarsiNumber";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

const PhoneVerification = () => {
  const { t, i18n } = useTranslation();
  const enqueueSnackbar = useSnackbar();
  const history = useHistory();
  const dispatch = useDispatch();
  const [countDown, setCountDown] = useState(60);
  const [resend, setResend] = useState(false);
  const firstInputRef = useRef(null);
  const username = useSelector((state) => state.auth);
  const phoneNumber = localStorage.getItem("phone");
  const [value, setValue] = useState({
    one: "",
    two: "",
    three: "",
    four: "",
    five: "",
    six: "",
  });
  const [valueArray, setValueArray] = useState([
    "null",
    "null",
    "null",
    "null",
    "null",
    "null",
  ]);

  const clickHandler = () => {
    let finalData = new FormData();
    finalData.append("code", valueArray.join(""));
    finalData.append("phone", username.phone || phoneNumber);
    postAxios(`${verificationApi}/`, finalData)
      .then((data) => {
        if (data.status === 200) {
          history.push("/app/users");
          dispatch(
            userSignInVerification({
              email: data.data.is_email_verified,
              phone: data.data.is_phone_verified,
              phoneNumber: data.data.phone,
            })
          );
          localStorage.setItem("isPhoneVerified", data.data.is_phone_verified);
          dispatch(showAuthMessageSuccess(data.data.message));
        }
      })
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
        dispatch(showAuthMessage(err.response.data.message));
        dispatch(hideMessage());
      });
  };

  const handleSubmit = (e) => {
    if (e.key === "Enter") {
      clickHandler();
    }
  };

  const changeHandler = (event, num) => {
    if (/^[0-9]*$/.test(event.target.value)) {
      const e = event.target;
      setValue({ ...value, [e.name]: e.value });
      setValueArray(
        valueArray.map((val, index) => {
          if (index.toString() === num) {
            return e.value;
          } else {
            return val;
          }
        })
      );
      if (num < 5 && e.value) {
        document.getElementById(num).focus();
      }
    }
  };

  useEffect(() => {
    sendPhoneRequest();
    firstInputRef.current.firstChild.focus();
    setCountDown(60);
  }, [resend]);

  const sendPhoneRequest = () => {
    let data = new FormData();
    data.append("username", phoneNumber);
    postAxios(`${verificationPhoneApi}`, data)
      .then((data) => {})
      .catch((err) => {
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  useEffect(() => {
    const verifyInterval = setInterval(() => {
      if (
        (username.isEmailVerified === "false" ||
          username.isEmailVerified === false) &&
        (username.isPhoneVerified === "true" ||
          username.isPhoneVerified === true)
      ) {
        history.push("/email-verification");
      } else if (
        username.isPhoneVerified === "true" ||
        username.isPhoneVerified === true
      ) {
        history.push("/app/users");
      }
    }, 100);
    return () => {
      clearInterval(verifyInterval);
    };
  }, []);

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => setCountDown(countDown - 1), 1000);
    }
  }, [countDown]);

  return (
    <div className="app-login-main-content">
      <div className="app-logo-content d-flex flex-column align-items-center justify-content-center">
        <span
          onClick={() => {
            history.push("/");
            dispatch(userSignOut());
          }}
          style={{
            position: "absolute",
            top: "25px",
            left: "35px",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          <span className="m-0 ">{t("validation.back")}</span>
          <ArrowBackIcon style={{ fontSize: "1.3rem" }} />
        </span>
        <div className="logo-lg">
          <SolarImage className="app-logo-content-logo" />
          <h1 className="bolder-text">{t("validation.world_wide")}</h1>
        </div>
      </div>
      <div className="app-login-content">
        <div className="app-login-header mb-4">
          <h1>{t("validation.phone_validation")}</h1>
        </div>
        <div className="app-login-header mb-4">
          <h3 style={{ textAlign: i18n.language === "fa" ? "right" : "left" }}>
            {t("validation.phone_validation_description_section_one")}
            <span style={{ color: "#5b5bd5" }}>
              {i18n.language === "fa"
                ? toFarsiNumber(username.phone || phoneNumber || "09000000000")
                : username.phone || phoneNumber || "09000000000"}{" "}
            </span>
            {t("validation.phone_validation_description_section_two")}
          </h3>
        </div>

        <div className="app-login-form">
          <form>
            <fieldset className="app-login-form2">
              <span className={classes.inputRoot}>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      ref={firstInputRef}
                      id="outlined"
                      name="one"
                      onChange={(e) => changeHandler(e, "0")}
                      onKeyPress={handleSubmit}
                      value={value.one}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="0"
                      name="two"
                      onChange={(e) => changeHandler(e, "1")}
                      onKeyPress={handleSubmit}
                      value={value.two}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="1"
                      name="three"
                      onChange={(e) => changeHandler(e, "2")}
                      onKeyPress={handleSubmit}
                      value={value.three}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="2"
                      name="four"
                      onChange={(e) => changeHandler(e, "3")}
                      onKeyPress={handleSubmit}
                      value={value.four}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="3"
                      name="five"
                      onChange={(e) => changeHandler(e, "4")}
                      onKeyPress={handleSubmit}
                      value={value.five}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="4"
                      name="six"
                      onChange={(e) => changeHandler(e, "5")}
                      onKeyPress={handleSubmit}
                      value={value.six}
                      inputProps={{
                        maxLength: 1,
                      }}
                    />
                  </FormControl>
                </div>
              </span>
              <div className={classes.timerContainer}>
                <h3
                  className={countDown == 0 ? classes.timerEnd : classes.timer}
                  onClick={() => {
                    if (countDown == 0) {
                      setResend(!resend);
                    }
                  }}
                >
                  {t("validation.send_again")}
                </h3>
                <h3 className={classes.timer}>{t("validation.up_to")}</h3>
                <h3 className={classes.timer}>
                  {i18n.language === "fa" ? (
                    <PersianPrice number={countDown} />
                  ) : (
                    countDown
                  )}
                </h3>{" "}
                <h3 className={classes.timer}>
                  {t("validation.another_second")}
                </h3>
              </div>
              <div className="mb-3 d-flex flex-column align-items-center justify-content-between w-100">
                <span className={classes.buttonRoot}>
                  <Button
                    className="btn btn-primary jr-btn-uptin"
                    onClick={clickHandler}
                    variant="contained"
                  >
                    {false ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : (
                      t("validation.send_verification_code")
                    )}
                  </Button>
                </span>
                {/* <span>
                  ساخت حساب کاربری
                  <Link to="/signup">
                    <IntlMessages id="signIn.signUp" />
                  </Link>
                </span> */}
              </div>
            </fieldset>
          </form>
        </div>
      </div>
      {/* {username.showMessage && NotificationManager.error(username.alertMessage)}
      <NotificationContainer /> */}
    </div>
  );
};

export default PhoneVerification;
